export interface PageMeta {
  title: string;
  description: string;
}

const SITE_NAME = 'EazyCalculators';

type MetaModule = { default: { route: string; seo: PageMeta } };
const metaModules = import.meta.glob<MetaModule>('../calculators/*/meta.ts', { eager: true });

const PAGE_META: Record<string, PageMeta> = {
  '/': {
    title: 'Free Online Calculators',
    description:
      'Free online calculators for compound interest, ROI, mortgages, auto loans, savings goals, retirement planning and many more. Simple, fast, and accurate.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy',
    description: 'EazyCalculators privacy policy. We do not collect personal data, use cookies, or track users.',
  },
  '/terms-of-service': {
    title: 'Terms of Service',
    description: 'Terms of service for EazyCalculators. All calculations are estimates for informational purposes only.',
  },
};

for (const mod of Object.values(metaModules)) {
  const meta = mod?.default;
  if (!meta?.route || !meta?.seo) continue;
  PAGE_META[meta.route] = meta.seo;
}

export function getPageMeta(pathname: string): { title: string; description: string } {
  const meta = PAGE_META[pathname] ?? PAGE_META['/'];
  return {
    title: `${meta.title} – ${SITE_NAME}`,
    description: meta.description,
  };
}
